var map = {
	"./feature_buy_en.png": "8acd",
	"./feature_buy_id.png": "08a0",
	"./feature_buy_ph.png": "7e12",
	"./feature_buy_th.png": "7c1d",
	"./feature_buy_zh.png": "c76a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc9b";